// deps
import React, { FC, ReactElement } from "react";
import usePortal from "@core-ui/hooks/UsePortal";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { useTheme } from "styled-components";

interface PortalProps {
    children: ReactElement;
    root?: string;
}

const Portal: FC<PortalProps> = (props: PortalProps) => {
    const theme = useTheme();

    if (typeof window === "undefined") {
        return null;
    }

    // allow configuring the portal root via a global variable, used on dweb
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const portalDefaultRoot = window?.__PAYMENTS_PORTAL_ROOT__ || "body";

    // eslint-disable-next-line react-hooks/rules-of-hooks,
    const portalRoot = usePortal(props.root ?? portalDefaultRoot);

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require("react-dom").createPortal(
        <ThemeProvider theme={theme} colorMode={theme.colorMode} design_language={theme.designLanguage}>
            {props.children}
        </ThemeProvider>,
        portalRoot,
    );
};

export default Portal;
